import React, {Component} from 'react';
import {changeUserPassword, getUserData, refreshToken, validateConfirmPass, validatePass} from '../services/UsersService';
import {showError, showInfo} from '../services/APIService';
import {
    Button,
    Descriptions,
    Form,
    Icon,
    Input,
    Spin,
    Tabs
} from 'antd';

const TabPane = Tabs.TabPane;

class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user: null,
            isLoading: false,
            userPassword: {},
            confirmPass: {},
            pass: {},
            oldPass: {}
        };
        this.loadUserProfile = this.loadUserProfile.bind(this);
    }

    handleUserPasswordValues = (property, value, validationFun, attributes) => {
        let userPassword = this.state.userPassword;
        userPassword[property] = value;
        this.setState({userPassword: userPassword});
        if (validationFun) {
            this.setState({
                [property]: {
                    value: value,
                    ...validationFun(value, attributes)
                }
            });
        }
    };

    enabledUpdateUserPassword = () => {
        return this.state.userPassword.oldPass
            && this.state.userPassword.pass
            && this.state.userPassword.confirmPass
            && !this.state.pass.errorMsg
            && !this.state.confirmPass.errorMsg;
    };

    updateUserPassword = () => {
        let userId = this.state.user.id;
        changeUserPassword(userId, this.state.userPassword.oldPass, this.state.userPassword.pass).then((response) => {
            if (response && response.id === userId) {
                showInfo('Su contraseña se ha actualizado. Debe iniciar sesión nuevamente a continuación', "Listo", false, e => this.props.onLogout());
            }
        }).catch(error => {
            if (error.status === 412) {
                showError('Su contraseña actual no es correcta. Intente nuevamente');
                return;
            }
            showError('Su solicitud no se puede procesar en este momento');
        });
    };

    loadUserProfile() {
        this.setState({
            isLoading: true
        });

        this.setState({
            user: getUserData(),
            isLoading: false
        });
    }

    componentDidMount() {
        this.loadUserProfile();
        refreshToken();
    }

    componentWillReceiveProps(nextProps) {
        this.loadUserProfile();
    }

    render() {
        const {form} = this.props;
        const {getFieldDecorator} = form;
        if (this.state.isLoading) {
            return <Spin size="large"/>;
        }
        const clients = this.state.user && this.state.user.clients ? this.state.user.clients : {}
    ;
        return (
            <div className="profile">
                {
                    this.state.user ? (
                        <div className="user-profile">
                            <Tabs type="card" size="large">
                                <TabPane key={"data"} tab={<span><Icon type="profile"/>Mis datos</span>}>
                                    <Descriptions bordered>
                                        <Descriptions.Item label="Usuario" span={2}>{this.state.user.id}</Descriptions.Item>
                                        {
                                            this.state.user.id !== this.state.user.email ? <Descriptions.Item label="Correo" span={2}>{this.state.user.email}</Descriptions.Item> : null
                                        }
                                        <Descriptions.Item label="Nombre" span={2}>{this.state.user.name}</Descriptions.Item>
                                        <Descriptions.Item label="Identificación" span={2}>{this.state.user.identification}</Descriptions.Item>
                                        <Descriptions.Item label="Mis direcciones" span={4}>
                                            {
                                                Object.keys(clients).map(c => {
                                                  return <p><b>{clients[c].name}:</b> {clients[c].userAddress}</p>
                                                })
                                            }
                                        </Descriptions.Item>
                                    </Descriptions>
                                </TabPane>
                                <TabPane key={"security"} tab={<span><Icon type="security-scan"/>Seguridad</span>}>
                                    <div className="login-container">
                                        <h1 className="page-title">Cambiar contraseña</h1>
                                        <div className="login-content">
                                            <Form.Item
                                                validateStatus={this.state.oldPass.validateStatus}
                                                help={this.state.pass.errorMsg}>
                                                {getFieldDecorator('oldPassword', {
                                                    rules: [{
                                                        required: !this.state.user.id,
                                                        message: 'Campo obligatorio',
                                                    }],
                                                })(
                                                    <Input
                                                        placeholder={'Contraseña actual'}
                                                        type="password" onChange={(value) => {
                                                        this.handleUserPasswordValues("oldPass", value.target.value);
                                                    }}/>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                validateStatus={this.state.pass.validateStatus}
                                                help={this.state.pass.errorMsg}>
                                                {getFieldDecorator('password', {
                                                    rules: [{
                                                        required: !this.state.user.id,
                                                        message: 'Campo obligatorio',
                                                    }],
                                                })(
                                                    <Input placeholder={'Contraseña'}
                                                           type="password" onChange={(value) => {
                                                        this.handleUserPasswordValues("pass", value.target.value, validatePass);
                                                    }}
                                                           onBlur={(value) => {
                                                               this.handleUserPasswordValues("confirmPass", this.state.userPassword.confirmPass, validateConfirmPass, this.state.userPassword.pass)
                                                           }}/>
                                                )}
                                            </Form.Item>
                                            <Form.Item
                                                validateStatus={this.state.confirmPass.validateStatus}
                                                help={this.state.confirmPass.errorMsg}>
                                                {getFieldDecorator('confirm', {
                                                    rules: [{
                                                        required: this.state.pass && this.state.pass.value,
                                                        message: 'Campo obligatorio',
                                                    }, {
                                                        validator: this.compareToFirstPassword,
                                                    }],
                                                })(
                                                    <Input
                                                        placeholder={'Confirmar contraseña'}
                                                        type="password"
                                                        onChange={(value) => {
                                                            this.handleUserPasswordValues("confirmPass", value.target.value, validateConfirmPass, this.state.userPassword.pass)
                                                        }}/>
                                                )}
                                            </Form.Item>
                                        </div>
                                        <Button type="primary"
                                                className="login-form-button"
                                                htmlType="submit"
                                                onClick={this.updateUserPassword}
                                                disabled={!this.enabledUpdateUserPassword()}>
                                            Aceptar
                                        </Button>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    ) : null
                }
            </div>
        );
    }
}

export default Form.create()(Profile);


// WEBPACK FOOTER //
// ./src/app/views/Profile.js